export const CONFIG_REGEX = <const>{
  EMAIL: /^[\w-.]+@([\w-]+\.)+[\w-]{2,4}$/,
  POSTALCODE: /^[0-9]{4} ?[A-z]{2}$/,
  PR6: /^(\d{1,12}|(\d{1,12}[,.]{1}\d{1,3}))$/,
  PR7: /^(\d{1,16}|(\d{1,16}[,.]{1}\d{1,3}))$/,
  UUR: /^(([\d]{1,12})|((?=[\d,]{1,15}$)\d*,\d{1,2})||((?=[\d.]{1,15}$)\d*\.\d{1,2}))$/,
  UU3: /^(([\d]{1,5})|((?=[\d,]{1,8}$)\d*,\d{1,2})||((?=[\d.]{1,8}$)\d*\.\d{1,2}))$/,
  UU4: /^(([\d]{1,5})|((?=[\d,]{1,8}$)\d*,\d{1,2})||((?=[\d.]{1,8}$)\d*\.\d{1,2}))$/,
};
